import React, { useEffect, useState } from 'react';
import { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';
import { toast } from 'react-toastify';
import { IJudgeGroupAssignment, IJudgingManagementProject, IListItem } from './JudgingInfoDataTypes';

import { IRoundDetails } from './JudgingCircles/JudgingCirlcesTypes';
import Button from '../_Core/Button';

interface IProps {
    focus:'judgeGroup'|'project';
    focusId:number;
    assignment?: IJudgeGroupAssignment;
    projects: IJudgingManagementProject[];
    judgeGroups: IListItem[];
    assignments: IJudgeGroupAssignment[];
    roundDetails: IRoundDetails;
    roundId: number;
    onSave:(x:IJudgeGroupAssignment)=>void;
    onRemoved:(x:IJudgeGroupAssignment)=>void;
}

const JudgeGroupAssignmentModal = (props: IProps) => {

    const [form, setForm] = useState<IJudgeGroupAssignment>({});
      const [date, setDate] = useState<string>('');
      const [time, setTime] = useState<string>('');

    useEffect(()=>{
        if(props.focus === 'judgeGroup'){
            setForm({...form, JudgeGroupId:props.focusId});
        } else if (props.focus === 'project'){
            setForm({...form, ProjectId:props.focusId});
        }
    },[]);

    useEffect(() => {
        if(props.assignment)
            setForm(props.assignment ?? {});
    }, [props.assignment]);


  const save = () => {

    let request = {
        id: props.assignment?.Id,
        projectId: form.ProjectId,
        judgeGroup: form.JudgeGroupId,
        roundId: props.roundId,
        date,
        time
      };

    store.server.postApi<ServerResponse<IJudgeGroupAssignment>>('../JudgingManagement/AssignJudgeGroup', request).then((x) => {
      if (x.Success) {
        toast.success('Assignment saved');
        props.onSave(x.Value);
      } else {
        toast.error(x.Message);
      }
    });
  };

  const remove = () => {
    if(!window.confirm('Are you sure you want to remove this assignment?')) return;

    let request = {assignmentId:props.assignment?.Id};

    store.server.postApi<ServerResponse<IJudgeGroupAssignment>>('../JudgingManagement/RemoveGroupAssignment', request).then((x) => {
      if (x.Success) {
        toast.success('Assignment removed');
        props.onRemoved(props.assignment);
      } else {
        toast.error(x.Message);
      }
    });

  };
  return (
    <div className='form-horizontal'>
        <div className='form-group'>
            <label className='col-sm-4 control-label'>Judge Group</label>
            <div className='col-sm-8'>
            <select
                className='form-control'
                value={form.JudgeGroupId+''}
                onChange={(e) => {
                    console.log(e.target.value+'');
                    console.log(props.judgeGroups);
                    setForm({ ...form, JudgeGroupId: +e.target.value });
                }        }
            >
                <option value='0'>Select Judge Group</option>
                {props.judgeGroups.map((x) => (
                <option key={x.id} value={x.id}>
                    {x.name}
                </option>
                ))}
            </select>
            </div>
        </div>
        <div className='form-group'>
            <label className='col-sm-4 control-label'>Project</label>
            <div className='col-sm-8'>
            <select
                className='form-control'
                value={form.ProjectId}
                onChange={(e) => {
                    setForm({ ...form, ProjectId: parseInt(e.target.value)});                
                }}
            >
                <option value='0'>Select Project</option>
                {props.projects.map((x) => (
                <option key={x.ProjectIntId} value={x.ProjectIntId}>
                    {x.ProjectId}
                </option>
                ))}
            </select>
            </div>
        </div>
        {props.roundDetails.SchedulesInterviews && <div className='form-group'>
            <label className='col-sm-4 control-label'>Interview At</label>
            <div className='col-sm-8'>
            <input
                type='date'
                className='form-control'
                value={date}
                onChange={(e) => setDate(e.target.value)}
            />
            <input
                type='time'
                className='form-control'
                value={time}
                onChange={(e) => setTime(e.target.value)}
            />
            </div>
        </div>}
        <div className='form-group'>
            <div className='col-sm-8 col-sm-offset-4'>
            <Button onClick={save} type='save' text='Save'/>
            {props.assignment && <Button onClick={remove} type='delete' text='Remove'/>}
            </div>
        </div>
    </div>
  );
};

export default JudgeGroupAssignmentModal;
